import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { ArrowLeftIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function CookiesPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="pt-20" data-id="element-624">
      <section className="relative py-16 md:py-20 bg-brand-navy overflow-hidden" data-id="element-625">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,_var(--tw-gradient-stops))] from-brand-royal/30 via-brand-navy to-brand-navy" data-id="element-626"></div>
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-627">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7
        }} data-id="element-628">
            <Link to="/" className="inline-flex items-center gap-2 text-white/60 hover:text-brand-gold transition-colors text-sm mb-8 group" data-id="element-629">
              <ArrowLeftIcon className="w-4 h-4 group-hover:-translate-x-1 transition-transform" data-id="element-630" />
              Volver al inicio
            </Link>
            <h1 className="text-4xl md:text-5xl font-heading font-bold text-white leading-tight" data-id="element-631">
              Política de{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-gold to-yellow-200" data-id="element-632">
                Cookies
              </span>
            </h1>
          </motion.div>
        </div>
      </section>

      <section className="py-16 md:py-20" data-id="element-633">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-gray-700 leading-relaxed space-y-8" data-id="element-634">
          <div data-id="element-635">
            <h2 className="font-heading font-bold text-brand-navy text-xl mb-3" data-id="element-636">
              1. INTRODUCCIÓN
            </h2>
            <p data-id="element-637">
              En REDORG utilizamos cookies y tecnologías similares para mejorar
              la experiencia de navegación en nuestros sitios web, analizar el
              tráfico, personalizar el contenido y mostrar anuncios relevantes.
              A continuación, te explicamos qué son las cookies, cómo las usamos
              y cómo puedes gestionarlas.
            </p>
          </div>

          <div data-id="element-638">
            <h2 className="font-heading font-bold text-brand-navy text-xl mb-3" data-id="element-639">
              2. ¿QUÉ SON LAS COOKIES?
            </h2>
            <p data-id="element-640">
              Las cookies son pequeños archivos de texto que un sitio web
              almacena en tu dispositivo (computadora, celular o tablet) al
              visitarlo. Estas permiten que el sitio "recuerde" tus acciones o
              preferencias (como idioma, inicio de sesión, etc.) durante un
              período de tiempo determinado.
            </p>
          </div>

          <div data-id="element-641">
            <h2 className="font-heading font-bold text-brand-navy text-xl mb-3" data-id="element-642">
              3. ¿QUÉ TIPOS DE COOKIES UTILIZAMOS?
            </h2>

            <h3 className="font-heading font-semibold text-brand-navy text-lg mt-4 mb-2" data-id="element-643">
              A. Cookies necesarias (técnicas):
            </h3>
            <p data-id="element-644">
              Permiten la navegación en el sitio web y el uso de sus funciones
              esenciales. Sin estas cookies, el sitio no puede funcionar
              correctamente.
            </p>

            <h3 className="font-heading font-semibold text-brand-navy text-lg mt-4 mb-2" data-id="element-645">
              B. Cookies de preferencia o personalización:
            </h3>
            <p data-id="element-646">
              Almacenan información para que el usuario acceda al servicio con
              características personalizadas, como el idioma o región.
            </p>

            <h3 className="font-heading font-semibold text-brand-navy text-lg mt-4 mb-2" data-id="element-647">
              C. Cookies de análisis o rendimiento:
            </h3>
            <p data-id="element-648">
              Nos permiten conocer el comportamiento de los visitantes para
              mejorar el sitio. Usamos herramientas como Google Analytics u
              otras similares.
            </p>

            <h3 className="font-heading font-semibold text-brand-navy text-lg mt-4 mb-2" data-id="element-649">
              D. Cookies de publicidad o marketing:
            </h3>
            <p data-id="element-650">
              Recopilan información sobre tus hábitos de navegación para
              mostrarte anuncios relevantes en nuestros sitios o en otros.
            </p>
          </div>

          <div data-id="element-651">
            <h2 className="font-heading font-bold text-brand-navy text-xl mb-3" data-id="element-652">
              4. ¿CUÁNTO TIEMPO PERMANECEN ACTIVAS?
            </h2>
            <ul className="list-disc ml-6 space-y-1" data-id="element-653">
              <li data-id="element-654">
                <strong data-id="element-655">Cookies de sesión:</strong> se eliminan al cerrar el
                navegador.
              </li>
              <li data-id="element-656">
                <strong data-id="element-657">Cookies persistentes:</strong> permanecen en tu
                dispositivo hasta que las elimines o expiren.
              </li>
            </ul>
          </div>

          <div data-id="element-658">
            <h2 className="font-heading font-bold text-brand-navy text-xl mb-3" data-id="element-659">
              5. ¿CÓMO PUEDES CONTROLAR LAS COOKIES?
            </h2>
            <p className="mb-3" data-id="element-660">
              Al ingresar por primera vez a nuestro sitio, se te mostrará un
              aviso de cookies. Puedes aceptar todas, rechazarlas o
              configurarlas según tu preferencia.
            </p>
            <p className="mb-3" data-id="element-661">
              Además, puedes modificar la configuración de cookies desde tu
              navegador en cualquier momento:
            </p>
            <ul className="list-disc ml-6 space-y-1" data-id="element-662">
              <li data-id="element-663">Google Chrome: Configuración de cookies</li>
              <li data-id="element-664">Mozilla Firefox: Administrar cookies</li>
              <li data-id="element-665">Safari: Soporte de Safari</li>
              <li data-id="element-666">Microsoft Edge: Privacidad y servicios</li>
            </ul>
          </div>

          <div data-id="element-667">
            <h2 className="font-heading font-bold text-brand-navy text-xl mb-3" data-id="element-668">
              6. COOKIES DE TERCEROS
            </h2>
            <p className="mb-3" data-id="element-669">
              Algunas cookies pueden ser instaladas por servicios de terceros
              utilizados en nuestro sitio (como redes sociales, plataformas de
              video, servicios de estadísticas, etc.). No tenemos control
              directo sobre ellas. Te recomendamos revisar sus respectivas
              políticas:
            </p>
            <ul className="list-disc ml-6 space-y-1" data-id="element-670">
              <li data-id="element-671">Google: Política de privacidad</li>
              <li data-id="element-672">Meta (Facebook / Instagram): Política de cookies</li>
            </ul>
          </div>

          <div data-id="element-673">
            <h2 className="font-heading font-bold text-brand-navy text-xl mb-3" data-id="element-674">
              7. CAMBIOS EN ESTA POLÍTICA
            </h2>
            <p data-id="element-675">
              Podemos actualizar esta Política de Cookies en cualquier momento.
              Te notificaremos en nuestro sitio web cuando se hagan cambios
              relevantes.
            </p>
          </div>

          <div data-id="element-676">
            <h2 className="font-heading font-bold text-brand-navy text-xl mb-3" data-id="element-677">
              8. CONTACTO
            </h2>
            <p data-id="element-678">
              Si tienes dudas sobre nuestra política de cookies, puedes
              escribirnos a:{' '}
              <a href="mailto:protecciondatos@redorg.net" className="text-brand-royal underline hover:text-brand-navy transition-colors" data-id="element-679">
                protecciondatos@redorg.net
              </a>
            </p>
          </div>

          <div data-id="element-680">
            <h2 className="font-heading font-bold text-brand-navy text-xl mb-3" data-id="element-681">
              9. VIGENCIA
            </h2>
            <p data-id="element-682">
              La vigencia de estas Políticas es desde el 20 de marzo de 2026 y
              permanecerá vigente hasta que exista una nueva versión que la
              reemplace.
            </p>
          </div>
        </motion.div>
      </section>
    </div>;
}